import apiClient from "../../../api/apiClient";


// ================= GET ALL =================
export const getCustomersApi =
  async (
    page: number,
    pageSize: number,
    search: string,
    tenantId: string
  ) => {

    const res =
      await apiClient.get(
        "/operations/customers",
        {
          params: {
            PageNumber: page,
            PageSize: pageSize,
            Search: search,
            TenantId: tenantId,
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= GET BY ID =================
export const getCustomerByIdApi =
  async (
    id: string,
    tenantId: string
  ) => {

    const res =
      await apiClient.get(
        `/operations/customers/${id}`,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= CREATE =================
export const createCustomerApi =
  async (
    data: any,
    tenantId: string
  ) => {

    const res =
      await apiClient.post(
        "/operations/customers",
        data,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= UPDATE =================
export const updateCustomerApi =
  async (
    data: any,
    tenantId: string
  ) => {

    const res =
      await apiClient.put(
        "/operations/customers",
        data,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= DELETE =================
export const deleteCustomerApi =
  async (
    id: string,
    tenantId: string
  ) => {

    const res =
      await apiClient.delete(
        `/operations/customers/${id}`,
        {
          params: {
            tenantId,
          },
        }
      );

    return res.data;

  };

// ================= GET ADDRESSES =================

export const getCustomerAddressesApi =
  async (
    customerId: string,
    page: number,
    pageSize: number,
    search: string,
    tenantId: string
  ) => {

    const res =
      await apiClient.get(
        `/operations/customers/${customerId}/addresses`,
        {
          params: {
            PageNumber: page,
            PageSize: pageSize,
            Search: search,
            TenantId: tenantId,
            tenantId
          }
        }
      );

    return res.data;

  };